import { render, staticRenderFns } from "./formHoatDongChuongTrinh.vue?vue&type=template&id=4dbb2b53&scoped=true&"
import script from "./formHoatDongChuongTrinh.vue?vue&type=script&lang=js&"
export * from "./formHoatDongChuongTrinh.vue?vue&type=script&lang=js&"
import style0 from "./formHoatDongChuongTrinh.vue?vue&type=style&index=0&id=4dbb2b53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb2b53",
  null
  
)

export default component.exports